import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./user.service";
import * as i2 from "./authentication.service";
import * as i3 from "@angular/router";
import * as i4 from "./request.service";
export class RouteGuardService {
    constructor(userService, authService, router, requestService) {
        this.userService = userService;
        this.authService = authService;
        this.router = router;
        this.requestService = requestService;
    }
    canActivate(route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.authService.getAcessToken()) {
                console.log('no auth token, taking to login page');
                return this.toLogin(state);
            }
            else if (this.authService.shouldRefreshToken()) {
                console.log('token expired, refreshing');
                let refreshed = yield this.requestService.refreshToken();
                if (!refreshed) {
                    return this.toLogin(state);
                }
            }
            const currentUser = yield this.userService.getCurrentUserAsync();
            if ((state.url.includes('/plantings/') && state.url.includes('/videos') && currentUser.permissions.canManagePlantingAreasVideo) ||
                (state.url.includes('/plantings/') && state.url.includes('/images') && currentUser.permissions.canManagePlantingAreasImage)) {
                return true;
            }
            if ((state.url.includes('/plantings/') && !currentUser.permissions.canManagePlantingSites) ||
                (state.url.includes('/admin/users') && !currentUser.permissions.canManageUsers) ||
                (state.url.includes('/admin/customers') && !currentUser.permissions.canManageCustomers) ||
                (state.url.includes('/certificates') && !currentUser.permissions.canManageCertificates) ||
                (state.url.includes('/new/general') && !currentUser.permissions.canManagePlantingSites)) {
                return this.router.navigate(['admin/login']);
            }
            return true;
        });
    }
    toLogin(state) {
        return this.router.createUrlTree(['/admin', 'login'], {
            queryParams: this.authService.getQueryParamsForRedirect(state.url)
        });
    }
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
}
RouteGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RouteGuardService_Factory() { return new RouteGuardService(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.AuthenticationService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.RequestService)); }, token: RouteGuardService, providedIn: "root" });
